import { dataFetcher } from 'core/services/requestHandler';   

const getPermissions = async (data = {}, config = {}) => {
  return dataFetcher('acl/permissions', data, {...config});
};

const savePermissions = async (data = {}, config = {}) => {
  return dataFetcher('acl/savePermissions', data, {method: 'POST', ...config});
};

export { getPermissions, savePermissions };
